import axios from "axios";
import { omitBy, isNull } from "lodash";
export class CSRFSetup {
    constructor() {
    }
    refresh(headers) {
        this.header = headers['x-csrf-header'];
        this.param = headers['x-csrf-param'];
        this.token = headers['x-csrf-token'];
    }
    append(request) {
        if (this.header)
            request.headers[this.header] = this.token;
    }
}
/**
 * Raw client to discuss with the server side from Glue.
 */
export class Api {
    constructor(glue) {
        this._csrf = new CSRFSetup();
        this.axios = axios.create({
            baseURL: glue.host,
            timeout: 30000,
            validateStatus: function (status) {
                return status >= 200 && status < 300;
            },
        });
        this.axios.interceptors.request.use((config) => {
            const axiosRequestConfig = glue.authentication ? glue.authentication.authenticate(config) : config;
            if (axiosRequestConfig)
                return axiosRequestConfig;
            else
                return config;
        });
        this.axios.interceptors.request.use((request) => {
            this._csrf.append(request);
            return request;
        });
        this.axios.interceptors.response.use((response) => {
            this._csrf.refresh(response.headers);
            return response;
        });
        //Remove null param from request
        this.axios.interceptors.request.use((request) => {
            request.params = omitBy(request.params, isNull);
            return request;
        });
    }
    get interceptors() {
        return this.axios.interceptors;
    }
    get defaults() {
        return this.axios.defaults;
    }
    delete(url, config) {
        return this.axios.delete(url, config);
    }
    get(url, config) {
        return this.axios.get(url, config);
    }
    getUri(config) {
        return this.axios.getUri(config);
    }
    head(url, config) {
        return this.axios.head(url, config);
    }
    options(url, config) {
        return this.axios.options(url, config);
    }
    patch(url, data, config) {
        return this.axios.patch(url, data, config);
    }
    post(url, data, config) {
        return this.axios.post(url, data, config);
    }
    put(url, data, config) {
        return this.axios.put(url, data, config);
    }
    request(config) {
        return this.axios.request(config);
    }
}
//# sourceMappingURL=Api.js.map